import { Component, OnInit } from "@angular/core";
import { AuthenticateService } from "../../app/shared/services/authenticate.service";
import {
  FormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { UUID } from "angular2-uuid";
import swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { FileUploadService } from "src/app/shared/services/fileupload.service";
import { TokenStorageService } from "../shared/services/token.service";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.sass"],
})
export class ProfileComponent implements OnInit {
  userObj: any = {};
  userForm: FormGroup;
  ImgUrl = this.authService.s3url();
  groupName = this.tokenService.getGroup();
  userData: any;
  url = "";
  alert: any[] = [];
  display: string = "none";
  newpassword: string = "";
  oldpassword: string = "";
  show: any[] = [];
  showEdit: boolean = false;
  imageUploadService: string;
  picture: any;
  userId: string = "";
  loading: boolean;

  constructor(
    private modalService: NgbModal,
    private cogService: CognitoService,
    private tokenService: TokenStorageService,
    private fileUploadService: FileUploadService,
    private authService: AuthenticateService,
    private formBuilder: FormBuilder,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit() {
    this.show[0] = false;
    this.show[1] = false;
    this.userForm = this.formBuilder.group({
      email: ["", Validators.required],
      newpassword: ["", Validators.required],
      oldpassword: ["", Validators.required],
    });
    if (this.groupName) this.userId = this.tokenStorage.getUser().username;
    this.getCurrentUser();
  }
  getCurrentUser() {
    this.cogService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
      this.userData = res.attributes;
      this.userObj = JSON.parse(this.userData["custom:userObj"]);
      this.userObj.gender = res.attributes.gender;
      this.userObj.picture = res.attributes.picture;
    });
  }
  // getCurrentUser(userId) {
  //   this.loading = true;
  //   this.userObj = {};
  //   let obj = {
  //     userId: userId
  //   }
  //   console.log("obj", obj);
  //   this.authService.getUserProfile(obj).then((data: any) => {
  //     console.log("user", data)
  //     if (data) {
  //       // let userdata = data.Users[0].Attributes.filter(obj => obj.Name == 'custom:userObj')[0].Value;
  //       // console.log(userdata);
  //       // this.userObj = JSON.parse(userdata);
  //       this.userObj = data;
  //       console.log("user", this.userObj);
  //       this.userData = this.userObj;
  //       this.loading = false;
  //     } else {
  //       this.loading = false;
  //     }
  //   });
  // }

  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => {
        // called once readAsDataURL is completed
        this.url = event.target.result;
      };
      let iuuid = UUID.UUID();
      this.imageUploadService =
        iuuid + "." + event.target.files.item(0).type.split("/")[1];
      this.picture = event.target.files[0];
    }
  }

  uploadFileToActivity() {
    if (this.picture != "") {
      // this.registerService.postFile(this.picture, this.imageUploadService).then(data => {
      //   // this.authService.refreshCurrentUser(this.imageUploadService, this.userObj['name']);
      // }, error => {
      //   console.log(error);
      // });
      this.fileUploadService.uploadFile(this.picture, this.imageUploadService);
    }
  }

  updateProfile() {
    swal
      .fire({
        title: "Are you sure want to UPDATE?",
        showCancelButton: true,
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
      })
      .then((value: any) => {
        if (value.value) {
          this.userObj["phone_number"] = this.userObj[
            "phone_number"
          ].startsWith("+91")
            ? this.userObj["phone_number"]
            : "+91" + this.userObj["phone_number"];
          this.userObj["picture"] =
            this.imageUploadService != undefined
              ? this.imageUploadService
              : this.userData.picture;
          delete this.userObj.username;
          delete this.userObj.group;
          this.cogService.updateUser(this.userObj).then((data: any) => {
            console.log("upadteProfile.response:- ", data);
            swal({ title: "Profile updated successfully" });
            if (this.picture) {
              this.uploadFileToActivity();
              this.getCurrentUser();
            } else {
              this.getCurrentUser();
            }
            this.showEdit = false;
          });
        }
      });
  }

  editProfile() {
    this.userObj["phone_number"] = this.userObj["phone_number"].startsWith(
      "+91"
    )
      ? this.userObj["phone_number"].substring(3, 13)
      : this.userObj["phone_number"];
    this.userObj["gender"] = this.userObj["gender"]
      ? this.userObj["gender"]
      : "";
    this.url = this.ImgUrl + this.userObj["picture"];
    this.showEdit = true;
  }

  onImgError(event) {
    event.target.src = this.ImgUrl + "agri_logo.png";
  }

  cancelEdit() {
    this.showEdit = false;
  }

  changepassword(content) {
    let config: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "sm",
    };
    this.modalService.open(content, config);
  }

  closemodal() {
    this.show[0] = false;
    this.show[1] = false;
    this.userForm.reset();
    this.oldpassword = "";
    this.newpassword = "";
    this.display = "none";
    for (let i = 0; i < 5; i++) {
      this.alert[i] = false;
    }
  }

  showhidepwd(type) {
    if (type == "password") {
      this.show[0] = !this.show[0];
    } else if (type == "newpassword") {
      this.show[1] = !this.show[1];
    }
  }

  updatenewPwd() {
    let obj: any = {
      username: this.userObj.username,
      oldPassword: this.oldpassword,
      newPassword: this.newpassword,
    };
    this.cogService.updateNewPassword(obj).then((data: any) => {
      if (data) {
        let response = JSON.parse(data.body);
        if (response.code && response.code == "NotAuthorizedException") {
          swal({ title: response.message });
        }
      } else {
        swal({ title: "New password updated successfully!" });
      }
      this.display = "none";
      for (let i = 0; i < 5; i++) {
        this.alert[i] = false;
      }
      this.userForm.reset();
      this.oldpassword = "";
      this.newpassword = "";
      this.show[0] = false;
      this.show[1] = false;
    });
  }

  focusFn() {
    this.display = "block";
  }

  checknewpassword(pwd) {
    if (pwd != "") {
      var lowerCaseLetters = /[a-z]/g;
      var upperCaseLetters = /[A-Z]/g;
      var numbers = /[0-9]/g;
      var specialchar = /[!@#\$%\^&\*]/g;
      for (let i = 0; i < 5; i++) {
        if (i == 0) {
          this.alert[i] = pwd.match(lowerCaseLetters) ? true : false;
        } else if (i == 1) {
          this.alert[i] = pwd.match(upperCaseLetters) ? true : false;
        } else if (i == 2) {
          this.alert[i] = pwd.match(numbers) ? true : false;
        } else if (i == 3) {
          this.alert[i] = pwd.match(specialchar) ? true : false;
        } else if (i == 4) {
          this.alert[i] = pwd.length >= 8 ? true : false;
        }
      }
    } else {
      for (let i = 0; i < 5; i++) {
        this.alert[i] = false;
      }
    }
  }
}
